<script setup>
import LIcon from "@/components/shared/LIcon.vue";
import { useUiStore } from "@/stores/ui";

const uiStore = useUiStore();

const props = defineProps({
  data: Object,
});

const action = async (type, data) => {
  await uiStore.setModalAction(type);
  uiStore.setModalState(true);
  await uiStore.setModalData(data);
};
</script>

<template>
  <div class="actions-cell">
    <button @click="action('delete_file_data_mapping_row', props.data)" type="button" class="icon-button danger" title="Delete">
      <LIcon name="trash-2" />
    </button>
  </div>
</template>
